@if (content(); as c) {
  @switch (c.hTag) {
    @case (hTag.H1) {
      <h1
        class="mb-0 text-3xl font-bold"
        [ngClass]="{
          '!mx-auto text-center': c.headlineAlignment === alignment.Center,
        }"
        [attr.id]="c.id ?? null"
        [innerHTML]="c.title | safeContent"
      ></h1>
      @if (showDivider()) {
        <div
          class="flex mt-1"
          [ngClass]="{
            'justify-center': c.headlineAlignment === alignment.Center,
          }"
        >
          <div class="w-8 h-1 mr-1 bg-[#F6CD4D]"></div>
        </div>
      }
    }
    @case (hTag.H2) {
      <h2
        class="mb-0 font-bold text-base/5 xs:text-lg/5 md:text-xl/6"
        [ngClass]="{
          '!mx-auto text-center': c.headlineAlignment === alignment.Center,
        }"
        [attr.id]="c.id ?? null"
        [innerHTML]="c.title | safeContent"
      ></h2>
      @if (showDivider() && !showDoubleDivider()) {
        <div
          class="w-6 h-[3px] mt-2 bg-[#F6CD4D]"
          [ngClass]="{ 'mx-auto': c.headlineAlignment === alignment.Center }"
        ></div>
      }
      @if (showDoubleDivider()) {
        <div
          class="flex"
          [ngClass]="{
            'justify-center': c.headlineAlignment === alignment.Center,
          }"
        >
          <div class="w-[48px] h-[6px] mt-2 mr-1 bg-[#F6CD4D]"></div>
        </div>
      }
    }
    @case (hTag.H3) {
      <h3
        class="mb-0 font-bold text-lg/6"
        [ngClass]="{
          '!mx-auto text-center': c.headlineAlignment === alignment.Center,
        }"
        [attr.id]="c.id ?? null"
        [innerHTML]="c.title | safeContent"
      ></h3>
      @if (showDivider()) {
        <div
          class="mt-1 h-[3px] w-6 bg-[#F6CD4D]"
          [ngClass]="{ 'mx-auto': c.headlineAlignment === alignment.Center }"
        ></div>
      }
    }
    @case (hTag.H4) {
      <h4
        class="mb-0 text-lg font-medium"
        [ngClass]="{
          '!mx-auto text-center': c.headlineAlignment === alignment.Center,
        }"
        [attr.id]="c.id ?? null"
        [innerHTML]="c.title | safeContent"
      ></h4>
    }
  }
}
